import { db } from "../../../service/API";

export class ProfileGroupConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
  }

  getGroupsData() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileGroupConnector/getGroupsData/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get groups data failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get groups data : " + err.message);
        });
    });
  }

  insertGroupData(groupObject) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileGroupConnector/insertGroupData/", {
        sid: this.socId,
        group: groupObject,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert group data failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("insert group data failed with error : " + err.message);
        });
    });
  }

  updateGroupData(groupObject, gid) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileGroupConnector/updateGroupData/", {
        gid: gid,
        group: groupObject,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update group data failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("update group data failed with error : " + err.message);
        });
    });
  }

  deleteGroupData(gid) {
    return new Promise((resolve, reject) => {
      db.delete("/ProfileGroupConnector/deleteGroupData/", {
        gid: gid,
        sid: this.socId,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else {
            return reject("delete group data failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete group data failed with error : " + err.message);
        });
    });
  }
}
